
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import ClinicalPictureSerializer from '../types/ClinicalPictureSerializer_apps_DPO'


const HOST = `${config.API_HOST}`
/* ['generics.ListCreateAPIView'] */
/* params:  */
/* data:  */
const MedicalRecordGalleryList : 
{
  list:     ({emr, params, apiToken, extra}:
             { emr: any, 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
  create:   ({emr, params, data, apiToken, extra}:
             { emr: any, 
                params?: any,
                data?: Partial<ClinicalPictureSerializer>,
                apiToken?: any,
                extra?: any
            }) => any,
} = 
{
  list: async ({emr, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/DPO/medical_record/gallery/${emr}/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  create: async ({emr, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.post(`${HOST}/apis/DPO/medical_record/gallery/${emr}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default MedicalRecordGalleryList

